import { type IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';
import styles from './styles.scss';

export const IconEye = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={iconStyles({ ...props, className: styles.watch })}
  >
    <path d="M12.01 6.91c4.98 0 9.32 3.5 10.95 5.01.03.02.04.05.04.09s-.01.06-.04.09c-1.63 1.5-5.97 5.01-10.95 5.01s-9.32-3.52-10.95-5.02c-.03-.02-.04-.05-.04-.09s.01-.06.04-.09c1.63-1.5 5.97-5.01 10.95-5.01m0-1c-5.3.01-9.82 3.62-11.63 5.28-.48.44-.48 1.2 0 1.64 1.8 1.66 6.33 5.27 11.63 5.27s9.82-3.61 11.63-5.27c.48-.44.48-1.2 0-1.64-1.8-1.66-6.33-5.27-11.63-5.27Z" />
    <path d="M5.94 9.79a6.27 6.27 0 0 0 5.9 7.83h.34a6.27 6.27 0 0 0 4.77-10.13" />
    <path d="M12.01 9.87a1.68 1.68 0 1 1 0 3.37 1.68 1.68 0 0 1 0-3.37m0-1a2.68 2.68 0 1 0 0 5.36 2.68 2.68 0 0 0 0-5.36Z" />
  </svg>
);
